import React from "react";
import projects from "../data/projects.json";

export default function ProjectsSection() {
  const production = projects.filter((p) => p.category === "production");
  const personal = projects.filter((p) => p.category === "personal");

  const renderGroup = (label, items) => (
    <>
      <p className="font-mono text-[12px] uppercase tracking-[0.1em] text-muted dark:text-pale mb-5 mt-10 first:mt-0">
        {label}
      </p>
      <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3 mb-4">
        {items.map((project, index) => (
          <div
            key={index}
            className="group bg-white dark:bg-[#101315] border border-black/10 dark:border-white/10 rounded-lg overflow-hidden transition-all duration-200 hover:-translate-y-1 hover:border-accent/60"
          >
            <div className="aspect-[16/10] overflow-hidden border-b border-black/10 dark:border-white/10">
              <img
                src={`/media/${project.thumbnail}`}
                alt={project.title}
                className="w-full h-full object-cover grayscale-[0.15] group-hover:grayscale-0 transition-[filter] duration-300"
              />
            </div>
            <div className="p-5">
              <h3 className="text-lg font-bold text-dark dark:text-white">
                {project.title}
              </h3>
              <p className="text-muted dark:text-pale mt-2 text-sm leading-relaxed">
                {project.description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </>
  );

  return (
    <div className="w-full">
      {production.length > 0 && renderGroup("Production", production)}
      {personal.length > 0 && renderGroup("Personal", personal)}
    </div>
  );
}
